export default __webpack_public_path__ + "static/media/error.a3e96bf8.svg";